import React, {forwardRef} from 'react'
import {useTranslation} from 'react-i18next'

import {Alert, AlertTitle, Box} from '@mui/material'
import {enqueueSnackbar} from 'notistack'

import {ReactComponent as CheckIcon} from '@progyny/assets/icons/consultation-row/check.svg'

interface ConsultationToastProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'color'
> {
  titleKey: string
  descriptionKey: string
}

const ConsultationToast = forwardRef<HTMLDivElement, ConsultationToastProps>(
  ({titleKey, descriptionKey, ...rest}, ref) => {
    const {t} = useTranslation()

    return (
      <Alert
        {...rest}
        ref={ref}
        severity='success'
        variant='outlined'
        icon={
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            width={'26px'}
            height={'26px'}
            borderRadius={'99px'}
            sx={{background: '#5CB3A3'}}
          >
            <CheckIcon width={14} height={14} />
          </Box>
        }
        sx={{
          width: '613px',
          alignItems: 'flex-start',
          background: '#E3FAE3',
          borderColor: '#C8EAC8',
          borderRadius: '12px',
          color: '#1E393B',
        }}
      >
        <AlertTitle sx={{fontSize: '14px', fontWeight: 700, margin: 0}}>
          {t(titleKey)}
        </AlertTitle>
        <Box sx={{fontSize: '12px'}}>{t(descriptionKey)}</Box>
      </Alert>
    )
  }
)

export const showConsultationRescheduledToast = () => {
  enqueueSnackbar('consultations_reschedule_toast_title', {
    key: 'consultation-rescheduled',
    content: (key) => (
      <ConsultationToast
        key={key}
        titleKey='consultations_reschedule_toast_title'
        descriptionKey='consultations_reschedule_toast_description'
      />
    ),
  })
}
export const showConsultationCancelledToast = () => {
  enqueueSnackbar('consultations_cancel_toast_title', {
    key: 'consultation-cancelled',
    content: (key) => (
      <ConsultationToast
        key={key}
        titleKey='consultations_cancel_toast_title'
        descriptionKey='consultations_cancel_toast_description'
      />
    ),
  })
}

export default ConsultationToast
